// Import Packages
import React, { useEffect, useState, useRef } from 'react'
import { useRecoilState, useSetRecoilState } from "recoil";
import HTMLReactParser from "html-react-parser";
import { useTranslation } from 'react-i18next';

// Import Material UI
import { Tooltip, Button } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import Close from "@material-ui/icons/Close";
import CircularProgress from '@material-ui/core/CircularProgress';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

// Import Pages

import { TextInput } from '../../FlowConfigurationInputs/TextInput/NewTextInput';
import BoolSelect from '../../FlowConfigurationInputs/BoolSelect/BoolSelect'
import VariablePicker from '../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import CustomTab from '../../FlowConfigurationInputs/CustomTab/CustomTab';
import CustomButton from "../../Button/Button";
import AppCredentialModal from "../../../home/pages/appCredential/appCredentialModal/AppCredentialModal";
import ConnectorField from "../../../home/pages/automs/newFlow/middleArea/connectorField/ConnectorField";
import { triggerConf, alertState, activeAutom } from "../../../recoil-store/recoil-state";

// Import Services
import VariableService from '../../../services/VariableService/VariableService';
import ActionService from '../../../services/ActionService/ActionService'
import ApplicationService from '../../../services/ApplicationService/ApplicationService';

// Import CSS
import './CustomAction.css';

const CustomAction = ({
    action,
    variables,
    setOpenVariable,
    variableRender,
    debuggingStart,
    debuggingExpand,
    automVersionId,
    automId,
    setVariables
}) => {

    const [applicationCredentials, setApplicationCredentials] = useState([]);
    const [appConnectors, setAppConnectors] = useState([]);
    const [selectedConnectors, setSelectedConnectors] = useState({});
    //const [selectedCustomSelectableField, setSelectedCustomSelectableField] = useState({});
    const [customInputs, setCustomInputs] = useState([]);
    const [itemId, setItemId] = useState();
    const [customOutputs, setCustomOutputs] = useState([]);
    const [applications, setApplications] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [openAppCredential, setOpenAppCredential] = useState(false);
    const [loading, setLoading] = useState(true);
    const [fieldOptions, setfieldOptions] = useState({});
    //const [selectedInputOption, setSelectedInputOption] = useState({});
    // application field congiguration application id
    const [aafcApplicationId, setAafcApplicationId] = useState('');
    const [sysActionFields, setSysActionFields] = useState({});
    // const [sampleResponses, setSampleResponses] = useState({});
    const [triggerConfig, setTriggerConfig] = useRecoilState(triggerConf);
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);

    const setAlert = useSetRecoilState(alertState);
    const sysActionFieldName = 'sys_action_fields';

    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.CUSTOM-ACTION."
    useEffect(() => {
        if (action.actionId) {
            if (!loading) {
                setLoading(true);
            }
            const fetchData = async () => {
                const res = await ActionService.getActionByFilter(action.actionId);
                //const actionFieldConf = await ActionService.getActionFieldConfiguration(action.actionId);

                // const res = await VariableService.getVariableFilter(action.autom_id, 1, 1);
                let data = res.data.variables.filter(x => !x.system_variable && (x.is_input || x.is_output));
                // find system application field variables by finding sys_ and _fields in the string
                let sysVariables = data.filter(x => x.name.substring(0, 4) === "sys_" && x.name.substring(x.name.length - 7) === "_fields");

                // find variable with type app connector
                const ac = data.filter(d => d.type === "app connector");

                // find application_id
                let app_id;
                if (res.data.action.application_action_field_configurations && res.data.action.application_action_field_configurations.length) {
                    app_id = res.data.action.application_action_field_configurations[0].application_id;
                }

                let sc = {};
                // set selected credential
                if (ac && ac.length) {
                    let appIds = [];
                    ac.map((c) => {
                        appIds.push(c.default_value);
                    })

                    // getting app credentials by using application ids
                    const appCredentials = await getApplicationCredentials(appIds);

                    if (appCredentials.length) {
                        setApplicationCredentials(appCredentials);
                    }

                    // set selectedConnectors
                    ac.map((c) => {
                        if (action.fields[c.name]?.value && appCredentials.find(x => x.id === action.fields[c.name]?.value)) {
                            sc[c.name] = { value: action.fields[c.name]?.value }
                        } else {
                            sc[c.name] = '';
                            action.fields[c.name] = { value: '', type: "app_connector", is_required: c.is_required }
                        }
                    })

                    setAppConnectors(ac)
                    setSelectedConnectors(sc);


                    // getting application by ids
                    const app = await getApplications({ id: appIds });
                    if (app && app.length) {
                        setApplications(app);
                    }
                }

                if (app_id) {
                    // if (res.data.action.application_action_field_configurations && res.data.action.application_action_field_configurations.length) {
                    //   const app_id = res.data.action.application_action_field_configurations[0].application_id;
                    setAafcApplicationId(app_id);
                    const conn = ac.find(c => c.default_value === app_id);
                    if (conn && sc[conn.name]) {
                        const app_connector_id = sc[conn.name].value;
                        await fetchInputOptions(app_connector_id);
                    }
                }

                // filtering input & autput variables to let user see those fields on the form
                data = data.filter(function (obj) {
                    // looking for system app fields variables is exist in variables
                    const sysSearch = sysVariables.find(x => x.name === obj.name)

                    // check if exists then make it hidden from configuration form
                    if (sysSearch) {
                        return obj.type !== "app connector" && obj.name !== sysSearch.name;
                    }

                    // return variables which has no type as app connector
                    return obj.type !== "app connector";
                });

                let inputs = [];
                let outputs = [];
                for (let item of data) {
                    if (!item.system_variable) {
                        if (item.is_input) {
                            if (!action.fields[item.name]) {
                                action.fields[item.name] = { value: item.default_value ? item.default_value : '', isRequired: item.is_required }
                            }
                            inputs.push(item);
                        } else {
                            if (!action.fields[item.name]) {
                                await createOutputVariable(item);
                            }
                            outputs.push(item);
                        }
                    }
                }
                inputs.sort((a, b) => (a.order > b.order) ? 1 : -1)
                outputs.sort((a, b) => (a.order > b.order) ? 1 : -1)

                if (action.fields[sysActionFieldName]) {
                    // let sysaf = {};
                    // Object.keys(action.fields[sysActionFieldName].value).map((c) => {
                    //     if (action.fields[sysActionFieldName].value[c]?.value) {
                    //         sysaf[c] = action.fields[sysActionFieldName].value[c]?.value;
                    //     } else {
                    //         sysaf[c] = '';
                    //     }
                    // })
                    // setSelectedCustomSelectableField(sysaf);
                    setSysActionFields(action.fields[sysActionFieldName].value);
                } else {
                    action.fields[sysActionFieldName] = { type: 'object', value: {} };
                }
                setCustomInputs(inputs);
                setCustomOutputs(outputs);
                setLoading(false);
                setItemId(action.item_id);
            }
            fetchData().then(r => r);
        }
    }, [refresh, action.item_id])

    const createOutputVariable = async (item) => {
        let variable = {
            name: '',
            type_id: item.type_id,
            autom_version_id: automVersionId,
            display_name: '',
            related_item_id: action.item_id,
            default_value: null,
            is_input: false,
            is_output: false,
            is_custimuzable: false,
        }
        let vv = variables.filter(x => x.name.includes('output_'));
        if (vv) {
            let number = 0;
            // Searching for the most recently created output
            for (const v of vv) {
                const n = parseInt(v.name.split('_')[1]);
                if (n > number) {
                    number = n;
                }
            }
            // set variable name
            variable.name = 'output_' + (number + 1);
        } else {
            variable.name = 'output_1';
        }
        const result = await VariableService.postVariable(variable);
        if (result && result.status) {
            action.fields[item.name] = { value: variable.name, isRequired: item.is_required }
            // update variables
            variable.id = result.id;
            variable.type = item.type;
            let copyVariable = [...variables];
            copyVariable.push(variable);
            setVariables(copyVariable);

            let copyItems = JSON.parse(JSON.stringify(automDetail.items))

            findAndUpdateItem(copyItems)
            setAutomDetail({
                ...automDetail,
                items: copyItems
            })

        } else {
            action.fields[item.name] = { value: '', isRequired: item.is_required }
        }
    }

    const findAndUpdateItem = (items) => {
        items.forEach(item => {
            if (item.item_id === action.item_id) {
                item.fields = JSON.parse(JSON.stringify(action.fields))
                return;
            } else if (item.children) {
                findAndUpdateItem(item.children)
            }
        })
    }

    const cancel = () => {
        setOpenAppCredential(false)
    }

    const afterSave = (t) => {
        setRefresh(t);
        setOpenAppCredential(false);
    }

    const getApplicationCredentials = async (ids) => {
        if (ids) {
            const response = await ApplicationService.getAppCredentials({ application_id: ids });
            if (response && response.status && response.data.length) {
                return response.data;
            }
        }
        return [];
    }

    const getApplications = async (filter = {}) => {
        const response = await ApplicationService.getApplications(filter);
        if (response && response.status && response.data.length) {
            return response.data;
        }

        return [];
    }

    const handleChangeCredential = async (credential_id, name) => {
        if (credential_id) {
            let copyConnectors = { ...selectedConnectors };
            copyConnectors[name] = { value: credential_id };
            setSelectedConnectors(copyConnectors);
            action.fields[name].value = credential_id;
            action.inputs = undefined;
            setLoading(true);
            await fetchInputOptions(credential_id);
            setLoading(false);
        }
    }

    const fetchInputOptions = async (app_connector_id) => {
        const resp = await ActionService.getInputValueOptions(action.actionId, app_connector_id, action.inputs);
        if (resp.code === 200) {
            //let _selectedInputOption = { ...selectedInputOption };
            // for (const key of Object.keys(resp.data)) {
            //     if (action.fields[key] && action.fields[key].value) {
            //         // if (action.fields[key].tab && action.fields[key].tab === 0 && !resp.data[key]?.options?.find(x => x.value === action.fields[key].value)) {
            //         //     //_selectedInputOption[key] = action.fields[key].value;
            //         //     action.fields[key].value = ""
            //         // }
            //         //else {
            //         //  action.fields[key].value = ""
            //         // _selectedInputOption[key] = ""
            //         //}
            //     }
            // }
            //setSelectedInputOption(_selectedInputOption);
            setfieldOptions(resp.data);
        }
    }

    const MyToolTip = ({ description }) => {
        return (
            description && (
                <Tooltip title={HTMLReactParser(description)}>
                    <InfoIcon style={{ width: 15, marginRight: 32, marginLeft: 5, position: "relative", top: 7 }} />
                </Tooltip>
            )
        )
    }

    // set action field
    const setSysField = async (inputName, value) => {

        let copyFields = { ...sysActionFields };
        if (!copyFields[inputName] && value.options && value.options.length === 0) {
            const conn = appConnectors.find(c => c.default_value === aafcApplicationId);
            if (conn && selectedConnectors[conn.name]) {
                const app_connector_id = selectedConnectors[conn.name].value;
                const resp = await ActionService.getSysFieldOptions(action.actionId, app_connector_id, [inputName], action.inputs);
                if (resp.code === 200 && resp.data[inputName]) {
                    value.options = resp.data[inputName].options;
                    value.type = 'select';
                    if (resp.data[inputName].option_fetch_error) {
                        value.option_fetch_error = true;
                    }
                }
            }
        }
        action.fields[sysActionFieldName].value[inputName] = value;
        setTimeout(() => {
            copyFields[inputName] = value;
            setSysActionFields(copyFields);
        }, 300)
    }

    // set action field
    const setSysSelectField = (inputName, value) => {
        let copyFields = { ...sysActionFields };
        copyFields[inputName].value = value;
        setSysActionFields(copyFields);
        //let copySelectedCustomSelectableField = { ...selectedCustomSelectableField };
        // copySelectedCustomSelectableField[inputName] = value;
        // setSelectedCustomSelectableField(copySelectedCustomSelectableField);
        action.fields[sysActionFieldName].value[inputName].value = value;
    }

    const removeCustomField = (inputName) => {
        let copyFields = { ...sysActionFields };
        delete copyFields[inputName]
        setSysActionFields(copyFields);
        delete action.fields[sysActionFieldName].value[inputName]
    }

    const removeCustomSelectField = (inputName) => {
        let copyFields = { ...sysActionFields };
        delete copyFields[inputName]
        setSysActionFields(copyFields);
        // let copySelectedCustomSelectableField = { ...selectedCustomSelectableField };
        // delete copySelectedCustomSelectableField[inputName];
        // setSelectedCustomSelectableField(copySelectedCustomSelectableField);
        delete action.fields[sysActionFieldName].value[inputName];
    }

    // select input field option
    const changeInputOption = (inputName, value) => {
        // let _selectedInputOption = { ...selectedInputOption };
        // // _selectedInputOption[inputName] = value;
        // setSelectedInputOption(_selectedInputOption);
        action.fields[inputName].value = value;
    }

    const checkAndOpenAppCredentialModal = (application_id) => {
        const app = applications.find(x => x.id === application_id)
        if (!app || !app.connector_fields) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('FLOW-MESSAGES.LIBRARY.GENERAL.UNKNOWN-ERROR'),
                severity: 'error'
            }));
            return;
        }
        setOpenAppCredential(true);
    }
    return (

        <>
            {appConnectors && appConnectors.length > 0 && (
                appConnectors.map(c => (
                    <div className="field-form-section">
                        <span className="dialog-text">{t(label + "CREDENTIAL")}</span>
                        <small className="credential-helper">{t(label + "CREDENTIAL-HELP")}</small>
                        <FormControl
                            variant="outlined"
                            style={{ width: "100%" }}
                        >
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                style={{
                                    backgroundColor: "#fff",
                                    height: "40px",
                                    fontSize: "12px",
                                }}
                                id="demo-simple-select-outlined"
                                value={selectedConnectors[c.name] ? selectedConnectors[c.name].value : ''}
                                onChange={(e) => handleChangeCredential(e.target.value, c.name)}
                            >
                                {applicationCredentials.length > 0 &&
                                    applicationCredentials.filter(x => x.application_id === c.default_value).map((cred) => (
                                        <MenuItem
                                            key={cred.id}
                                            style={{ fontSize: 12 }}
                                            value={cred.id}
                                        >
                                            {cred.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                        <div className="add-credential">
                            <CustomButton value={t(label + "NEW-CREDENTIAL")} minWidth={"100%"}
                                onClick={() => checkAndOpenAppCredentialModal(c.default_value)} />
                        </div>
                        {openAppCredential &&
                            <AppCredentialModal selectedApp={applications.find(x => x.id === c.default_value)}
                                afterSave={afterSave} cancel={cancel} />}

                        {aafcApplicationId === c.default_value && selectedConnectors[c.name] &&
                            <ConnectorField showFieldPreview={!!selectedConnectors[c.name]}
                                triggerConfig={triggerConfig}
                                setTriggerConf={setTriggerConfig} automVersionId={automVersionId}
                                triggerExpanded={false} debugOpen={debuggingStart} action={action}
                                debugExpand={debuggingExpand} onFlowPage={true} automId={automId}
                                selectedCredential={selectedConnectors[c.name]}
                                disabledFields={sysActionFields}
                                setDisabledFields={setSysField}
                                rightLocation={true} //sampleResponses={sampleResponses}
                                variables={variables} setOpenVariable={setOpenVariable}
                                disableInputs={customInputs}
                            />
                        }
                    </div>
                ))
            )}

            {/* {selectedConnectors[connectorName] &&
                <ConnectorField showFieldPreview={!!selectedConnectors[connectorName]} triggerConfig={triggerConfig}
                    setTriggerConf={setTriggerConfig} automVersionId={automVersionId}
                    triggerExpanded={false} debugOpen={debuggingStart} action={action}
                    debugExpand={debuggingExpand} onFlowPage={true} automId={automId}
                    selectedCredential={selectedConnectors[connectorName]} disabledFields={sysActionFields}
                    setDisabledFields={setSysField} rightLocation={true} customItems={customItems} />
            } */}
            {
                loading ? <CircularProgress className='loading-circular-process' /> :
                    appConnectors.length && selectedConnectors[appConnectors.find(x => x.default_value === aafcApplicationId)?.name] && itemId === action.item_id && (
                        <>
                            {
                                customInputs.length || customOutputs.length ? (
                                    <div>

                                        <div className="custom-form-fields">
                                            {
                                                customInputs?.map(inputVariable =>

                                                    <div className="form-element">
                                                        <div>
                                                            {inputVariable?.display_name ? inputVariable?.display_name : inputVariable?.name}
                                                            {/* {inputVariable?.description &&
                                                                <MyToolTip description={inputVariable?.description} />} */}
                                                        </div>
                                                        {
                                                            fieldOptions[inputVariable.name] &&
                                                                (fieldOptions[inputVariable.name].options && fieldOptions[inputVariable.name].options.length ||
                                                                    fieldOptions[inputVariable.name].option_fetch_error) ? (

                                                                <CustomTab action={action} displayName={inputVariable.name}
                                                                    isRequired={inputVariable.is_required}
                                                                    inputName={inputVariable?.name}
                                                                    options={fieldOptions[inputVariable.name].option_fetch_error ? [] : fieldOptions[inputVariable.name].options}
                                                                    type={inputVariable.type}
                                                                    variableRender={variableRender}
                                                                    variables={variables}
                                                                    setOpenVariable={setOpenVariable}
                                                                    optionFetchError={fieldOptions[inputVariable.name].option_fetch_error}
                                                                    onChange={(v) => changeInputOption(inputVariable.name, v)}
                                                                />
                                                                // <FormControl
                                                                //     variant="outlined"
                                                                //     style={{ width: "100%" }}
                                                                // >
                                                                //     <Select
                                                                //         labelId="demo-simple-select-outlined-label"
                                                                //         style={{
                                                                //             backgroundColor: "#fff",
                                                                //             height: "40px",
                                                                //             fontSize: "12px",
                                                                //         }}
                                                                //         value={selectedInputOption[inputVariable.name]}
                                                                //         id="demo-simple-select-outlined"
                                                                //         onChange={(e) => changeInputOption(inputVariable.name, e.target.value)}
                                                                //     >
                                                                //         {
                                                                //             fieldOptions[inputVariable.name].options.map((cred) => (
                                                                //                 <MenuItem
                                                                //                     style={{ fontSize: 12 }}
                                                                //                     value={cred.value}
                                                                //                 >
                                                                //                     {cred.display_name}
                                                                //                 </MenuItem>
                                                                //             ))}
                                                                //     </Select>
                                                                // </FormControl>

                                                            ) :
                                                                (
                                                                    inputVariable.type === 'boolean' ?
                                                                        <BoolSelect
                                                                            inputName={inputVariable?.name}
                                                                            variableRender={variableRender}
                                                                            variables={variables}
                                                                            action={action}
                                                                            displayName={inputVariable?.name}
                                                                            setOpenVariable={setOpenVariable}
                                                                            type={inputVariable?.type}
                                                                            isRequired={inputVariable.is_required}
                                                                            onChange={changeInputOption}
                                                                        />
                                                                        :
                                                                        <TextInput inputName={inputVariable?.name}
                                                                            variableRender={variableRender}
                                                                            variables={variables}
                                                                            action={action}
                                                                            include={[inputVariable.type]}
                                                                            multiline={inputVariable?.type === "object"}
                                                                            setOpenVariable={setOpenVariable}
                                                                            isRequired={inputVariable.is_required}
                                                                            fieldType={inputVariable?.type}
                                                                            displayName={inputVariable?.name}
                                                                        />
                                                                )
                                                        }
                                                        {inputVariable?.description && inputVariable?.description !== '<p><br></p>' &&
                                                            <small><em>{HTMLReactParser(inputVariable?.description)}</em></small>
                                                        }
                                                    </div>
                                                )
                                            }
                                            <hr id="configuration-seperator" />
                                            {customOutputs?.map(outputVariable =>
                                                <div className="form-element">
                                                    <div>
                                                        {outputVariable?.display_name ? outputVariable?.display_name : outputVariable?.name}
                                                        {/* {outputVariable?.description &&
                                                            <MyToolTip description={outputVariable?.description} />} */}
                                                        {/* {
                                                outputVariable?.description && (
                                                    <Tooltip title={HTMLReactParser(outputVariable?.description)}>
                                                        <InfoIcon style={{ width: 15, marginRight: 32 }} />
                                                    </Tooltip>
                                                )
                                            } */}
                                                    </div>

                                                    <VariablePicker action={action} inputName={outputVariable?.name}
                                                        variables={variables}
                                                        disabled={action.fields[outputVariable?.name] && action.fields[outputVariable?.name].value}
                                                        setOpenVariable={setOpenVariable}
                                                        styles={{ backgroundColor: "white" }}
                                                        filter={outputVariable?.type}
                                                        isRequired={outputVariable.is_required}
                                                        isOutput={true}
                                                    />
                                                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: outputVariable?.type })}</em></small>
                                                    {HTMLReactParser(outputVariable?.description) &&
                                                        <small><em>{HTMLReactParser(outputVariable?.description)}</em></small>
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{
                                        padding: "50px 10px",
                                        color: "#e39b9b",
                                        textAlign: "center"
                                    }}>{t('CONTENT.CONFIGURATION-FORM.NO-CONFIGURABLE-VARIABLE-FOUND')}</div>
                                )
                            }
                            {
                                Object.entries(sysActionFields).length > 0 &&
                                (
                                    <div>
                                        <h4>{t(label + "INPUT-FIELDS")}</h4>
                                        {
                                            Object.entries(sysActionFields).map(([path, obj]) => (
                                                <div className="form-element">
                                                    <div>

                                                        {obj.displayName ? obj.displayName : obj.name}
                                                        <MyToolTip description={path} />
                                                        <Button size="small" data-test="cancelautom-button"
                                                            onClick={() => obj.type === 'select' ? removeCustomSelectField(path) : removeCustomField(path)}>
                                                            <Close />
                                                        </Button>
                                                    </div>
                                                    {
                                                        obj.type === 'select' && (obj.options && obj.options.length ||
                                                            obj.option_fetch_error) ? (
                                                            <CustomTab action={action.fields[sysActionFieldName].value}
                                                                displayName={obj.name}
                                                                inputName={path}
                                                                options={obj.option_fetch_error ? [] : obj.options}
                                                                type={obj.type} variableRender={variableRender}
                                                                variables={variables}
                                                                setOpenVariable={setOpenVariable}
                                                                setField={setSysField}
                                                                optionFetchError={obj.option_fetch_error}
                                                                onChange={(v) => setSysSelectField(path, v)}
                                                            />
                                                            // <FormControl
                                                            //     variant="outlined"
                                                            //     style={{ width: "100%" }}
                                                            // >
                                                            //     <Select
                                                            //         labelId="demo-simple-select-outlined-label"
                                                            //         style={{
                                                            //             backgroundColor: "#fff",
                                                            //             height: "40px",
                                                            //             fontSize: "12px",
                                                            //         }}
                                                            //         value={selectedCustomSelectableField[path]}
                                                            //         id="demo-simple-select-outlined"
                                                            //         onChange={(e) => setSysSelectField(path, e.target.value)}
                                                            //     >
                                                            //         {
                                                            //             obj.options.map((cred) => (
                                                            //                 <MenuItem
                                                            //                     style={{ fontSize: 12 }}
                                                            //                     value={cred.value}
                                                            //                 >
                                                            //                     {cred.display_name}
                                                            //                 </MenuItem>
                                                            //             ))}
                                                            //     </Select>
                                                            // </FormControl>

                                                        ) :
                                                            (
                                                                obj.type === 'boolean' ?
                                                                    <BoolSelect
                                                                        inputName={path}
                                                                        variableRender={variableRender}
                                                                        variables={variables}
                                                                        action={action.fields[sysActionFieldName].value}
                                                                        displayName={obj?.name}
                                                                        setOpenVariable={setOpenVariable}
                                                                        type={obj?.type}
                                                                        isRequired={true}
                                                                        setField={setSysField}
                                                                        onChange={setSysSelectField}
                                                                    />
                                                                    :
                                                                    <TextInput
                                                                        inputName={path}
                                                                        action={action.fields[sysActionFieldName].value}
                                                                        setField={setSysField}
                                                                        variableRender={variableRender}
                                                                        variables={variables}
                                                                        include={[obj.type]}
                                                                        multiline={obj?.type === "object"}
                                                                        setOpenVariable={setOpenVariable}
                                                                        isRequired={true}
                                                                        fieldType={obj.type}
                                                                        displayName={obj.name}
                                                                    />
                                                            )
                                                    }

                                                </div>
                                            ))
                                        }
                                    </div>
                                )
                            }
                        </>
                    )
            }


        </>
    )
}

export default CustomAction
